import { render } from "./sectionClips.vue?vue&type=template&id=1df316d1&scoped=true"
import script from "./sectionClips.vue?vue&type=script&lang=js"
export * from "./sectionClips.vue?vue&type=script&lang=js"

import "./sectionClips.vue?vue&type=style&index=0&id=1df316d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df316d1"]])

export default __exports__